module.exports = __webpack_public_path__ + "img/fashion_99.a1a593d7.jpg";